"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentAssignment = void 0;
/**
 * It contains information about the student assignment
 *
 * @property {string}  id                 - Unique identifier of the assignment
 * @property {string}  districtId         - Unique identifier of the organization/institution the assignment belongs to
 * @property {string}  schoolId           - Unique identifier of the school the assignment belongs to
 * @property {Date}    dueDate            - Date at which the user assignment was due
 * @property {string}  enrollmentPeriodId - Unique identifier of the enrollment period the assignment belongs to
 * @property {string}  ownerId            - Unique identifier of the user who created the assignment
 * @property {string}  contextId          - Unique identifier of the context/class the assignment belongs to
 * @property {string}  title              - Title of the assignment
 * @property {string}  instructions       - Instructions of the assignment
 * @property {Date}    startedAt          - Date at which the assignment was started
 * @property {Date}    completedAt        - Date at which the assignment was completed
 * @property {string}  status             - Current state of the assignment. Acceptable values: assigned, done
 * @property {Date}    assignedAt         - Date at which the assignment was assigned
 * @property {string}  bundleId           - Unique identifier to group assignments in bundles
 * @property {string}  curriculumId       - Unique identifier of the curriculum the assignment belongs to
 * @property {string}  evidenceType       - Indicates the evidence type
 *
 */
var StudentAssignment = /** @class */ (function () {
    function StudentAssignment(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    return StudentAssignment;
}());
exports.StudentAssignment = StudentAssignment;
